import React from "react";
import "./Vision.css";

export default function Vision() {
  return (
    <section className="vision">
      <h2>Notre Vision</h2>
      <div className="vision-content" style={{ display: 'flex', alignItems: 'center', gap: '32px', justifyContent: 'center', textAlign: 'left' }}>
        <div className="vision-image">
           <img src={require("../../assets/images/vision.png")} alt="Notre vision" />
        </div>
        <div className="vision-text">
          <p>
            Avec une équipe de collaborateurs et d’experts intervenant dans des
            domaines variés tels que le développement web, la data, l’intelligence
            artificielle, le conseil IT, ainsi que la transformation digitale, <span style={{ color: '#a020f0', fontWeight: 'bold' }}>NEXUS SOLUTIONS</span>
            se distingue par la qualité de son management et le
            professionnalisme de son personnel.
          </p>
          <p>
            Les atouts de <span style={{ color: '#a020f0', fontWeight: 'bold' }}>NEXUS SOLUTIONS</span> résident dans le respect des objectifs de
            coûts, des délais, de la qualité et des délais de performance définis par
            ses clients. Cette stratégie permet ainsi de réaliser des performances
            remarquables et de s’imposer comme un partenaire de confiance dans
            l’écosystème numérique africain.
          </p>
        </div>
      </div>
    </section>
  );
}
